'use client';

import { PostHogProvider } from '@monorepo/common';
import { Provider } from 'jotai';
import { SessionProvider, useSession } from 'next-auth/react';

export const JotaiProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => <Provider>{children}</Provider>;

export const AuthProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => <SessionProvider>{children}</SessionProvider>;

/**
 * PostHog Provider をアプリ側の next-auth セッションに接続する。
 *
 * 各ログイン経路を個別に修正せず、セッションを単一の真実として顧客ID（distinctId）を渡し、
 * identify / reset の切り替えは共通 Provider 側に委譲する。
 * `useSession` を使うため AuthProvider（SessionProvider）の内側に配置すること。
 */
export const AnalyticsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { data: session } = useSession();
  // 顧客IDは数値型のため、PostHog の distinctId（文字列）に合わせて変換する。
  const distinctId = session?.user?.id != null ? String(session.user.id) : null;
  return <PostHogProvider distinctId={distinctId}>{children}</PostHogProvider>;
};
